import React, { useContext, useState } from "react";
import { GlobalErrorContext } from "./GlobalErrorContext";
import styles from "./GlobalErrorMessage.module.css";

export const GlobalErrorMessage: React.FunctionComponent = props => {
	const { errorMessage, errorCause, clearError } = useContext(GlobalErrorContext);
	const [showStack, setShowStack] = useState(false);

	if (errorMessage === "") {
		return null;
	}

	return (
		<div className={styles.globalError}>
			<div className={styles.globalErrorMessageContainer}>
				<div className={styles.globalErrorMessage}>
					{errorMessage}
					{errorCause !== undefined ? `: ${errorCause.message}` : ``}
				</div>
				<div>
					<button onClick={clearError}>Clear</button>
					{errorCause !== undefined ? (
						<button onClick={() => setShowStack(prev => !prev)}>Toggle Stack</button>
					) : null}
				</div>
			</div>
			<div className={styles.globalErrorStack}>
				{showStack && errorCause !== undefined ? <pre>{errorCause.stack}</pre> : null}
			</div>
		</div>
	);
};
